export const CREATE_STUDENT = 0;
export const MASS_INSCRIPTION = 1;
export const STUDENT_INSCRIPTION = 2;